// Off-app destinations on the association's website.
export const PRIVACY_POLICY_URL =
  "https://www.elternverein-kaiseraugst.ch/datenschutz";
// Membership details + yearly fee live on the website only — the fee amount
// may change and must not be persisted on the payment page.
export const MEMBERSHIP_INFO_URL =
  "https://www.elternverein-kaiseraugst.ch/mitglied-werden";
// Full event details (films, times, all conditions) — single source of truth
// in shared (the delivery email links there too).
export { EVENT_INFO_URL } from "@evka/shared/constants";
export const CONTACT_EMAIL = "info@elternverein-kaiseraugst.ch";
